<div class="page-wrapper pt-4">
    <div class="page-content pt-0 pe-2 ps-2">
        <div class="container-fluid">
            <div class="default_class">
                <div class="content-wrapper p-0">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="card rounded shadow-lg">
                                    <div class="card-header  headerbg" style="border-bottom:3px solid #d8eff8;">
                                        <h5 class="mb-0">{{headingName.SubChapters}}</h5>
                                    </div>

                                    <div class="card-body">
                                        <div class="text-right">
                                            <button type="button" class="btn btn-primary mb-1" data-bs-toggle="modal"
                                                data-bs-target="#myModal" (click)="add()">Add</button>
                                        </div>
                                        <div *ngIf="table.length">
                                            <table id="patreggraph" datatable
                                                class=" table-striped table-bordered mt-2 pt-2 table-sm small"
                                                style="width:100%">
                                                <thead class="top" style="background-color: #624FD7; color:#ffffff;">
                                                    <tr>
                                                        <th> Chapter </th>
                                                        <th> Sub Chapter Name </th>
                                                        <th>
                                                            Sub Chapter Description
                                                        </th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of table">
                                                        <td>{{item.chapter_name}}</td>
                                                        <td>{{item.sub_chapter_name}}</td>
                                                        <td>{{item.sub_chapter_description}}</td>
                                                        <td>{{item.sub_chapter_status ==true?'Active':'InActive'}}</td>
                                                        <td style="display: flex;">
                                                            <span data-bs-toggle="modal" data-bs-target="#myModal"
                                                                src="" class="edit_icon"
                                                                (click)="edit(item.sub_chapter_id)">
                                                                <i class="fas fa-pen pt-1 mt-1"></i></span>
                                                        </td>

                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="text-center" *ngIf="!table.length">
                                            No Records to display
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal" id="myModal" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header py-2">
                <h6 *ngIf="!isEdit" class=" modal-title w-100"> {{headingName.AddSubChapter}}</h6>
                <h6 *ngIf="isEdit" class="modal-title w-100"> {{headingName.EditSubChapter}}</h6>
                <button type="button" (click)="close()" class="close" data-bs-dismiss="modal"><i
                        class="fas fa-times"></i></button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <form class="well form-horizontal" [formGroup]="myForm" (ngSubmit)="onSubmit(myForm)">
                    <fieldset>
                        <div class="form-group row">
                            <label class="col-md-4 control-label line_2 rem_1">
                                {{labelName.CourseName}}<span class="text-danger">*</span></label>
                            <div class="col-md-8 inputGroupContainer">
                                <div class="input-group"><strong>:</strong> &nbsp;
                                    <select (change)="courseChange($any($event).target.value)"
                                        class="form-select form-select-sm shadow-sm rounded-lg" id="sel1"
                                        formControlName="course_id">
                                        <option value="" [selected]="true">select</option>
                                        <option *ngFor="let course of courses" [value]='course.COURSE_ID'>
                                            {{course.COURSE_NAME}}
                                        </option>

                                    </select>
                                </div>
                                <div *ngIf="myForm.get('course_id')?.touched">
                                    <span class="text-danger" *ngIf="myForm.get('course_id').hasError('required')">
                                        This field is required.
                                    </span>

                                </div>
                            </div>
                        </div>&nbsp;&nbsp;

                        <div class="form-group row">
                            <label class="col-md-4 control-label line_2 rem_1">
                                {{labelName.CourseSchedule}}<span class="text-danger">*</span></label>
                            <div class="col-md-8 inputGroupContainer">
                                <div class="input-group"><strong>:</strong> &nbsp;
                                    <select
                                        class="form-select form-select-sm shadow-sm rounded-lg" id="sel1"
                                        (change)="sheduleChange($any($event).target.value)"
                                        formControlName="courseshd_id">
                                        <option value="" [selected]="true">select</option>
                                        <option *ngFor="let shedule of shedules" [value]='shedule.COURSESHD_ID'>
                                            {{shedule.COURSESHD_NAME}}
                                        </option>
                                    </select>
                                </div>
                                <div *ngIf="myForm.get('courseshd_id')?.touched">
                                    <span class="text-danger" *ngIf="myForm.get('courseshd_id').hasError('required')">
                                        This field is required.
                                    </span>

                                </div>
                            </div>
                        </div>&nbsp;&nbsp;

                        <div class="form-group row">
                            <label class="col-md-4 control-label line_2 rem_1">
                                {{labelName.Chapter}}<span class="text-danger">*</span></label>
                            <div class="col-md-8 inputGroupContainer">
                                <div class="input-group"><strong>:</strong> &nbsp;
                                    <select class="form-select form-select-sm shadow-sm rounded-lg" id="sel1"
                                        formControlName="chapter_id">
                                        <option value="" [selected]="true">select</option>
                                        <option *ngFor="let chapter of chapters" [value]='chapter.CHAPTER_ID'>
                                            {{chapter.CHAPTER_NAME}}
                                        </option>

                                    </select>
                                </div>
                                <div *ngIf="myForm.get('chapter_id')?.touched">
                                    <span class="text-danger" *ngIf="myForm.get('chapter_id').hasError('required')">
                                        This field is required.
                                    </span>

                                </div>
                            </div>
                        </div>
                        <div class="form-group row pt-4">
                            <label class="col-md-4 control-label line_2 rem_1">
                                {{labelName.SubChapterName}} <span class="text-danger">*</span></label>
                            <div class="col-md-8 inputGroupContainer">
                                <div class="input-group"><strong>:</strong> &nbsp;
                                    <input type="text" placeholder="" class="form-control"
                                        formControlName="sub_chapter_name">
                                </div>
                                <div *ngIf="myForm.get('sub_chapter_name')?.touched">
                                    <span class="text-danger"
                                        *ngIf="myForm.get('sub_chapter_name').hasError('required')">
                                        This field is required.
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row pt-4">
                            <label class="col-md-4 control-label line_2 rem_1">
                                {{labelName.SubChapterDescription}} <span class="text-danger">*</span></label>
                            <div class="col-md-8 inputGroupContainer">
                                <div class="input-group"><strong>:</strong> &nbsp;
                                    <input type="text" placeholder="" class="form-control"
                                        formControlName="sub_chapter_description">
                                </div>
                                <div *ngIf="myForm.get('sub_chapter_description')?.touched">
                                    <span class="text-danger"
                                        *ngIf="myForm.get('sub_chapter_description').hasError('required')">
                                        This field is required.
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row pt-4">
                            <label class="col-md-4 control-label">{{labelName.Status}}<span
                                    class="text-danger">*</span></label>
                            <div class="col-md-8 inputGroupContainer">
                                <div class="input-group"><strong>:</strong> &nbsp;
                                    <select class="form-control form-control-sm shadow-sm rounded-lg" id="sel1"
                                        formControlName="sub_chapter_status">
                                        <option [ngValue]=true>Active</option>
                                        <option [ngValue]=false>InActive </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </form>

            </div>
            <div class="modal-footer">
                <button type="button" *ngIf="!isEdit" class="btn btn-sm  btn-save" (click)="onSubmit(myForm)"
                    [disabled]="myForm.invalid">Save</button>
                <button type="button" *ngIf="isEdit" class="btn btn-sm  btn-save" (click)="onSubmit(myForm)"
                    [disabled]="myForm.invalid">Update</button>
                <button type="button" class="btn btn-sm btn-danger" id="md_close" (click)="close()"
                    data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>